module.exports = __webpack_public_path__ + "static/media/flatbread-home.d94a7189.svg";